export type QuerySelector = <T extends Element>(selector: string) => T | null;

export function resolveQuerySelector(querySelector?: QuerySelector): QuerySelector {
  return querySelector
    ?? (<T extends Element>(selector: string): T | null => document.querySelector<T>(selector));
}

export function setText(element: HTMLElement | null, text: string): void {
  if (element !== null) {
    element.textContent = text;
  }
}
